import React from 'react';
import styled from 'styled-components';

import { breakpoint } from '../../../lib/style/ThemeStyle';

export const HorizonGreyLine = ({ ...props }) => {
  return <LineWrapper {...props} />;
};

const LineWrapper = styled.div`
  width: 100vw;
  background: ${(props) => props.theme.background.grey};
  height: 0.625rem;
  margin-left: calc(-${breakpoint / 2}px + 50%);
  max-width: ${breakpoint}px;

  @media (max-width: ${breakpoint}px) {
    margin-left: calc(-50vw + 50%);
  }
`;
